<script lang="ts" context="module">
	declare global {
		interface Window {
			grecaptcha: {
				execute(): Promise<void>;
				reset(): void;
				getResponse(): string;
				ready(cb: () => void): void;
			};
		}
	}
</script>

<script lang="ts">
	import { getSharedGlobalSettings } from "../../getSharedGlobalSettings.js";
	import { handleInvalidInputs } from "./handleInvalidInputs.js";

	export let form: HTMLFormElement | null = null;
	export let id = "";
	export let onsubmit: ((event: SubmitEvent) => void) | undefined = undefined;

	const { RECAPTCHA_SITE_KEY } = getSharedGlobalSettings();

	let formClass = "";
	export { formClass as class };

	let ready = false;
	async function waitForReadyRecatpcha(): Promise<void> {
		if (ready) {
			return;
		}
		await new Promise((resolve) => {
			setInterval(() => {
				if (ready) {
					resolve(undefined);
				}
			}, 500);
		});
	}

	async function handleAntispamSubmit(event: SubmitEvent): Promise<void> {
		event.preventDefault();

		await waitForReadyRecatpcha();
		await window.grecaptcha.execute();
		const token = window.grecaptcha.getResponse();
		if (token) {
			window.grecaptcha.reset();
			onsubmit?.(event);
		}
	}

	function recaptcha(_element: HTMLElement): void {
		window.grecaptcha.reset();
		window.grecaptcha.ready(() => {
			ready = true;
		});
	}

	/* eslint-disable svelte/no-at-html-tags */
</script>

<svelte:head>
	{@html `<script src="https://www.google.com/recaptcha/api.js" async defer></script>`}
</svelte:head>

<form
	bind:this={form}
	class={formClass}
	{id}
	on:submit={handleAntispamSubmit}
	use:handleInvalidInputs
	on:change
	on:input
>
	<div class="g-recaptcha" data-sitekey={RECAPTCHA_SITE_KEY} data-size="invisible" use:recaptcha></div>

	<slot />
</form>
